import React from 'react';
import PropTypes from 'prop-types';

const GoogleSearchLink = ({ q, children, disabled = false }) => {
  const encodedQuery = encodeURIComponent(q);

  return (
    <a
      href={disabled ? '#' : `https://www.google.com/search?q=${encodedQuery}`}
      target="_blank"
      rel="noopener noreferrer"
      className={disabled ? 'no-pointer-events' : ''}
    >
      {children}
    </a>
  );
};

GoogleSearchLink.propTypes = {
  q:        PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

export default GoogleSearchLink;
